module.exports = __webpack_public_path__ + "img/products.3bf389fd.jpg";